"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Chart = require("chart.js");
var Help_1 = __importDefault(require("./Help")); //N.B. different paths, seems "@/ts/filenamewithoutextn" only works in .vue files 
var Colorer = /** @class */ (function () {
    function Colorer(colors) {
        this.colors = colors;
        this.index = 0;
    }
    Colorer.prototype.next = function () {
        var color = this.colors[this.index];
        if (this.index - 1 < this.colors.length - 1) {
            this.index++;
        }
        return color;
    };
    return Colorer;
}());
var ChartHelp = /** @class */ (function () {
    function ChartHelp() {
    }
    ChartHelp.dynamicNumericTickLabels = function (value, index, values) {
        var maxTick = Help_1.default.maxOfArray(values);
        if (maxTick === 1) {
            return value;
        }
        else if (maxTick >= 1000000) {
            return (value / 1000000) + 'M';
        }
        else if (maxTick >= 5000) {
            return (value / 1000) + 'K';
        }
        return value;
    };
    ChartHelp.mergeChartData = function (clientSpec, serverData) {
        return {
            labels: serverData.labels,
            datasets: clientSpec.datasets.map(function (ds, i) { return Object.assign({}, ds, serverData.datasets[i]); })
        };
    };
    ChartHelp.mergeChartDataForNDatasets = function (clientDatasetSpec, serverData) {
        return {
            labels: serverData.labels,
            datasets: serverData.datasets.map(function (ds, i) { return Object.assign({}, ds, clientDatasetSpec); })
        };
    };
    ChartHelp.mergeChartDataForNDatasetsAndColor = function (clientDatasetSpec, serverData) {
        var colorer = new Colorer(ChartHelp.defaultPortfolioColors);
        var datasets = serverData.datasets.map(function (ds, i) { return Object.assign({}, ds, clientDatasetSpec); });
        datasets.forEach(function (ds) { return ds.backgroundColor = colorer.next(); });
        return {
            labels: serverData.labels,
            datasets: datasets
        };
    };
    ChartHelp.mergeChartDataForNDatasetsAndColorize = function (clientDatasetSpec, serverData, colors) {
        var colorer = new Colorer(colors);
        var datasets = serverData.datasets.map(function (ds, i) { return Object.assign({}, ds, clientDatasetSpec); });
        datasets.forEach(function (ds) { return ds.backgroundColor = colorer.next(); });
        return {
            labels: serverData.labels,
            datasets: datasets
        };
    };
    ChartHelp.getGapAnalysisLegendData = function (portfolioNames) {
        var colorer = new Colorer(ChartHelp.defaultPortfolioColors);
        return portfolioNames.map(function (item, index) {
            return { key: index, name: item, color: colorer.next() };
        });
    };
    ChartHelp.currencyFormatLabel = function (tooltipItem, data) {
        var label = data.datasets[tooltipItem.datasetIndex].label || '';
        if (label) {
            label += ': ';
        }
        var formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
        var valueToDisplay = formatter.format(tooltipItem.yLabel);
        return label + " " + valueToDisplay;
    };
    ChartHelp.defaultEmptyData = function () {
        return {
            labels: [],
            datasets: []
        };
    };
    ChartHelp.getTicks = function (callback, additionalValues) {
        var respVal = {
        //fontColor: "rgba(255, 255, 255, 0.7)",
        //fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        //fontSize: 14,
        //fontStyle: "300"
        };
        if (!Help_1.default.isNullOrUndef(callback)) {
            respVal["callback"] = callback;
        }
        return Object.assign(respVal, additionalValues);
    };
    ChartHelp.defaultChartGridLinesX = function () {
        return {
            display: false,
            zeroLineWidth: 0,
            drawBorder: false,
        };
    };
    ChartHelp.defaultChartGridLinesY = function () {
        return {
            drawBorder: false,
            borderDash: [1, 3],
            color: "rgba(0, 0, 0, 0.4)",
            lineWidth: 0.5,
            zeroLineBorderDash: [1, 3],
            zeroLineColor: "rgba(0, 0, 0, 0.4)",
            zeroLineWidth: 0.5,
            drawTicks: false
        };
    };
    ChartHelp.getGridLinesX = function (additionalValues) {
        var respVal = ChartHelp.defaultChartGridLinesX();
        return Object.assign(respVal, additionalValues);
    };
    ChartHelp.getGridLinesY = function (additionalValues) {
        var respVal = ChartHelp.defaultChartGridLinesY();
        return Object.assign(respVal, additionalValues);
    };
    ChartHelp.defaultMiniChartGridLinesY = function () {
        return ChartHelp.getGridLinesY({ color: "rgba(255, 255, 255, 0.4)", zeroLineColor: "rgba(255, 255, 255, 0.4)" });
    };
    ChartHelp.defaultMiniChartLayout = function () {
        return {
            padding: {
                top: 30,
                right: 30,
                bottom: 5,
                left: 15
            }
        };
    };
    ChartHelp.setDefaults = function () {
        ChartHelp.setFontDefaults();
        ChartHelp.setTooltipDefaults();
    };
    ChartHelp.setFontDefaults = function () {
        Chart.defaults.global.defaultFontColor = ChartHelp.defaultFontColor;
        Chart.defaults.global.defaultFontFamily = ChartHelp.defaultFontFamily;
        Chart.defaults.global.defaultFontSize = ChartHelp.defaultFontSize;
        Chart.defaults.global.defaultFontStyle = ChartHelp.defaultFontStyle;
    };
    ChartHelp.setTooltipDefaults = function () {
        Chart.defaults.global.tooltips.backgroundColor = ChartHelp.tooltipBackgroundColor;
        Chart.defaults.global.tooltips.bodyFontColor = ChartHelp.tooltipTitleFontColor;
        Chart.defaults.global.tooltips.titleFontFamily = ChartHelp.defaultFontFamily;
        Chart.defaults.global.tooltips.titleFontSize = ChartHelp.defaultFontSize;
        Chart.defaults.global.tooltips.titleFontStyle = ChartHelp.defaultFontStyle;
        Chart.defaults.global.tooltips.titleFontColor = ChartHelp.tooltipTitleFontColor;
        Chart.defaults.global.tooltips.xPadding = ChartHelp.tooltipxPadding;
        Chart.defaults.global.tooltips.yPadding = ChartHelp.tooltipyPadding;
        Chart.defaults.global.tooltips.cornerRadius = ChartHelp.tooltipCornerRadius;
    };
    ChartHelp.dummyChart = function (chart) {
        ChartHelp.dummyChartData(chart);
        chart.update();
    };
    ;
    ChartHelp.dummyChartData = function (chart) {
        for (var x = 0; x < chart.data.datasets.length; x++) {
            var dataSet = chart.data.datasets[x];
            for (var i = 0; i < dataSet.data.length; i++) {
                dataSet.data[i] = Help_1.default.randomScalingFactor();
            }
        }
    };
    ;
    ChartHelp.defaultPortfolioColors = ["#00bcd4" /*light blue*/, "rgb(244, 67, 54)" /*Red*/, "#ff9800" /*yellow*/, "rgb(76, 175, 80)" /*green*/, "gray"];
    ChartHelp.defaultTaskColors = ["rgb(76, 175, 80)" /*green*/, "gray"];
    //static defaultWebsiteStatusColors: string[] = ["rgb(93, 173, 164)" /*light green*/, "rgb(255, 152, 0)", "rgb(244, 67, 54)" /* red */, "rgb(76, 175, 80)" /*green*/];   
    ChartHelp.defaultWebsiteStatusColors = ["rgb(93, 173, 164)" /*light green text-semi-success*/, "rgb(255, 152, 0)" /* text-warning */, "rgb(244, 67, 54)" /* text-danger red */, "rgb(157, 225, 160)" /* success-ish*/, "rgb(76, 175, 80)" /* text-success green*/]; //4caf50 
    ChartHelp.defaultDueStatusColors = ["rgb(76, 175, 80)" /*green*/, "#ff9800" /*yellow*/, "rgb(244, 67, 54)" /*Red*/, "gray"];
    ChartHelp.defaultMiniChartTooltipDisplayColors = false;
    ChartHelp.defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
    ChartHelp.defaultFontColor = "rgba(255, 255, 255, 0.7)";
    ChartHelp.defaultFontSize = 14;
    ChartHelp.defaultFontStyle = "300";
    ChartHelp.tooltipFontColor = "#3c4858";
    ChartHelp.tooltipTitleFontColor = "rgba(0, 0, 0, 1)";
    ChartHelp.tooltipBackgroundColor = "rgba(255, 255, 255, 0.9)";
    ChartHelp.tooltipxPadding = 10;
    ChartHelp.tooltipyPadding = 10;
    ChartHelp.tooltipCornerRadius = 3;
    return ChartHelp;
}());
exports.default = ChartHelp;
//# sourceMappingURL=chartHelp.js.map